import { usePathname } from "next/navigation";
import React from "react";

import LeftComponent from "./sections/LeftComponent";
import RightComponent from "./sections/RightComponent";
import SearchComponent from "./sections/SearchComponent";
import styles from "./navbar.module.scss";

function Navbar({ onSideCall, watchPoint, className }) {
  const pathname = usePathname();

  const isCoursesPage = pathname === "/courses";
  const topHeaderClass = isCoursesPage
    ? `${styles["courses-nav"]}`
    : `${styles["navbox"]}`;

  return (
    <section className={`${topHeaderClass} ${className}`} id="header">
      <LeftComponent onSideCall={onSideCall} />
      <SearchComponent />
      <RightComponent points={watchPoint} />
    </section>
  );
}

export default Navbar;
